import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ProjectCreate" }
const _hoisted_2 = { class: "ProjectCreate__properties" }
const _hoisted_3 = { class: "ProjectCreate__tools" }

import { ref } from "vue";
import IconButton from "@/components/ds/icon-button/IconButton.vue";
import { useProjectStore } from "@/stores/projects";
import api from "@/api";
import { useUiStore } from "@/stores/ui";
import { useClientStore } from "@/stores/clients";
import { useEmployeeStore } from "@/stores/employees";
import InnSelect from "@/components/ds/select/Select.vue";
import InnInput from "@/components/ds/input/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCreate',
  setup(__props) {

const projectsStore = useProjectStore();
const clientsStore = useClientStore();
const employeesStore = useEmployeeStore();
const uiStore = useUiStore();

const name = ref("");
const client_id = ref(null);

const createProject = () => {
    if (name.value.length > 0 && client_id.value) {
        const project = projectsStore.getNew();
        const client = clientsStore.getItemById(client_id.value);
        project.projectName = name.value;
        project.clientId = client_id.value;
        if (client) {
            project.rate = client.rate;
        }
        api.create(project, "projects").then((response) => {
            project.id = response.id;
            project.user_id = response.user_id;
            projectsStore.create(project);
            uiStore.message("Project aangemaakt..");
            //router.push({ name: "Project", params: { id: project.id } });
        });
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InnInput, {
        modelValue: name.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
        placeholder: "Naam van project..."
      }, null, 8, ["modelValue"]),
      _createVNode(InnSelect, {
        items: _unref(clientsStore).list,
        modelValue: client_id.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((client_id).value = $event)),
        "item-title": "name",
        "item-value": "id"
      }, null, 8, ["items", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(IconButton, {
        disabled: name.value.length === 0 || !client_id.value,
        "icon-id": "plus",
        onClick: createProject
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" Project aanmaken ")
        ])),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})